export default __webpack_public_path__ + "static/media/@rafaelapinheirooficial.b2c84baa.png";